"use strict";

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _superagent = _interopRequireDefault(require("superagent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SCSessionService = /*#__PURE__*/function () {
  function SCSessionService() {
    _classCallCheck(this, SCSessionService);
  }

  _createClass(SCSessionService, null, [{
    key: "setSession",
    value: function () {
      var _setSession = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(idToken) {
        var payload, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = {
                  id: idToken
                };
                _context.next = 3;
                return _superagent.default.post('/api/callbackauthentication').send(payload).set('accept', 'json');

              case 3:
                response = _context.sent;
                return _context.abrupt("return", response);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function setSession(_x) {
        return _setSession.apply(this, arguments);
      }

      return setSession;
    }()
  }, {
    key: "keepAliveSession",
    value: function () {
      var _keepAliveSession = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(idToken) {
        var payload, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                payload = {
                  id: idToken
                };
                _context2.next = 3;
                return _superagent.default.post('/api/keepaliveauthentication').send(payload).set('accept', 'json');

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function keepAliveSession(_x2) {
        return _keepAliveSession.apply(this, arguments);
      }

      return keepAliveSession;
    }()
  }, {
    key: "endSession",
    value: function () {
      var _endSession = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(token) {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _superagent.default.get('/api/authentication/spalogout').set({
                  'X-OktaTokenJson': token,
                  // eslint-disable-next-line quote-props
                  Authorization: "Bearer ".concat(token)
                }).set('accept', 'json');

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function endSession(_x3) {
        return _endSession.apply(this, arguments);
      }

      return endSession;
    }()
  }]);

  return SCSessionService;
}();

exports.default = SCSessionService;
//# sourceMappingURL=SCSessionService.js.map